<template>
  <!-- 国内旅行対応 -->
  <div id="AppDomesticTravelSearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">国内旅行検索</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="旅行期間" labelPosition="on-border">
              <b-datepicker
                v-model="searchConditions.startDate"
                name="startDate"
                type="day"
                placeholder="検索開始年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
              <b-datepicker
                v-model="searchConditions.endDate"
                name="endDate"
                type="day"
                placeholder="検索終了年月日"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="点検担当者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="点検担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="点検担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field
              label="患者名(カナ)"
              labelPosition="on-border"
              :type="{'is-danger':errors.has('patientNameKana')}"
              :message="errors.first('patientNameKana')"
            >
              <b-input
                v-model="searchConditions.patientNameKana"
                name="patientNameKana"
                data-vv-as="患者名(カナ)"
                type="text"
                field="patientNameKana"
                v-validate="'kanaCheck'"
                @typing="kanaInitialization()"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-two-thirds">
            <b-field label="ステータス" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button v-model="searchConditions.travelStatusGroup" native-value="1">予定</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.travelStatusGroup" native-value="5">旅行中</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.travelStatusGroup" native-value="2">旅行終了</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.travelStatusGroup" native-value="3">キャンセル</b-checkbox-button>
              <b-checkbox-button v-model="searchConditions.travelStatusGroup" native-value="4">完了</b-checkbox-button>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span
              style="color: red"
              v-if="isSearchConditionKana&&!this.kanaJudg(searchConditions.patientNameKana)"
            >検索条件に誤りがあります。</span>
            <span style="color: red" v-else-if="isSearchConditionNull">検索条件を指定してください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
      <travelSearchResult
        ref="searchResult"
        v-bind:search-conditions="searchConditions"
        v-bind:patient-info="patientInfo"
        v-bind:current-patient="currentPatient"
        v-bind:is-before-patient="isBeforePatient"
        v-bind:is-add="isAdd"
      />
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import resultTemplate from "./AppDomesticTravelSearchResult";
var data = [];
export default {
  name: "AppDomesticTravelSearch",
  methods: {
    kanaInitialization: function() {
      this.isSearchConditionKana = false;
    },
    search: function(searchConditions) {
      if (
        this.searchConditions.startDate ||
        this.searchConditions.endDate ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.isLength(this.searchConditions.patientCode) ||
        this.isLength(this.searchConditions.patientName) ||
        this.isLength(this.searchConditions.patientNameKana) ||
        this.searchConditions.travelStatusGroup.length > 0
      ) {
        if (
          this.isLength(this.searchConditions.patientNameKana) &&
          !this.kanaJudg(this.searchConditions.patientNameKana)
        ) {
          this.isSearchConditionKana = true;
        } else {
          console.log("検索条件あり");
          this.isSearchConditionNull = false;
          // 検索条件の整形
          for (var val in this.searchConditions.travelStatusGroup) {
            this.searchConditions.travelStatusGroup[val] = parseInt(
              this.searchConditions.travelStatusGroup[val]
            );
          }
          if (
            this.searchConditions.startDate &&
            !(typeof this.searchConditions.startDate == "string")
          ) {
            this.searchConditions.startDate = this.formatDate(
              this.searchConditions.startDate
            );
          }
          if (
            this.isLength(this.searchConditions.patientNameKana) &&
            !this.kanaJudg(this.searchConditions.patientNameKana)
          ) {
            this.isSearchConditionKana = true;
          } else {
            console.log("検索条件あり");
            this.isSearchConditionNull = false;
            // 検索条件の整形
            for (var val in this.searchConditions.travelStatusGroup) {
              this.searchConditions.travelStatusGroup[val] = parseInt(
                this.searchConditions.travelStatusGroup[val]
              );
            }
            if (
              this.searchConditions.startDate &&
              !(typeof this.searchConditions.startDate == "string")
            ) {
              this.searchConditions.startDate = this.formatDate(
                this.searchConditions.startDate
              );
            }
            if (
              this.searchConditions.endDate &&
              !(typeof this.searchConditions.endDate == "string")
            ) {
              this.searchConditions.endDate = this.formatDate(
                this.searchConditions.endDate
              );
            }
            // 検索実行
            this.$refs.searchResult.search(this.searchConditions);
          }
        }
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
      }
    }
  },
  data() {
    var patientInfo = {};
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var currentPatient = "";
    var isBeforePatient = false;
    var isAdd = true;
    var searchConditions = {
      officeCode: "",
      startDate: "",
      endDate: "",
      staffCode: "",
      staffName: "",
      patientCode: "",
      patientName: "",
      patientNameKana: "",
      travelStatusGroup: []
    };
    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
      if (
        typeof searchConditions.startDate == "string" &&
        searchConditions.startDate != ""
      ) {
        searchConditions.startDate = this.parseDate(searchConditions.startDate);
      }
      if (
        typeof searchConditions.endDate == "string" &&
        searchConditions.endDate != ""
      ) {
        searchConditions.endDate = this.parseDate(searchConditions.endDate);
      }
    } else if (this.$route.params["patientCode"] == undefined) {
      if (userInfo.roleId != 1 && userInfo.roleId != 2) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.staffCode = userInfo.staffCode;
        searchConditions.staffName = userInfo.fullName;
      }
    } else {
      currentPatient = this.$route.params["patientCode"];
      isBeforePatient = this.$route.params["isBeforePatient"];
      isAdd = this.$route.params["isAdd"];
      patientInfo = this.$route.params["patientInfo"];
      searchConditions.patientCode = this.$route.params["patientCode"];
      searchConditions.patientName = patientInfo.name;
    }
    return {
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      isStaffChangeModalActive: false,
      isAddAppointmentActive: false,
      searchConditions,
      isSearchConditionNull: false,
      isSearchConditionKana: false,
      patientInfo,
      userInfo,
      currentPatient,
      isBeforePatient,
      isAdd
    };
  },
  filters: {},
  components: {
    travelSearchResult: resultTemplate
  },
  mounted: function() {
    // WebApi Call
    this.search();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppDomesticTravelSearch.vue